export default "__VITE_ASSET__BwQ5b04f__"